import { number } from 'prop-types';
import React, { forwardRef } from 'react';
import { makeProjectsActionType, resource } from '../state/action';
import Project from './projects';

const monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];

const prepareYearWiseProjectList = function(data) {
    try {
        var projectsList = {},prevAlbumYear;
        
        data.forEach(function (val,index) {
            var projectDate = getProjectDate(val);            
            val.resource.id = val.resource._id              
            var key = "y"+projectDate.year;            
            if (!(key in projectsList)) {
                prevAlbumYear = projectDate.year;
                projectsList[key] = [];
                projectsList[key].push(val);
            } else if (prevAlbumYear === projectDate.year && projectsList.hasOwnProperty(key)) {
                //group for same date
                projectsList[key].push(val);
            }
        });
        return projectsList;
    } catch (e) {
        //@ts-ignore
        photoOrg.clientLogger.error({description: "NEW PROJECTS:projects_view:prepareYearWiseProjectList:Exception", errorCode: "LIBRARY:MYPROJECTS", err_desc: e, err_stack: e.stack});
    }
}

const getmonthHeaderData = (projectDate,projectState) => {
    return {
        'year': projectDate.year,
        'month': projectDate.month,
        //@ts-ignore
        'date' : moment(projectDate.originalDate).format('YYYY'),
        'deletedProject' : (projectState === 'deleted' ? true : false)
    };
}
const createTemplate = (project,projectState) => {
    try {
        //When No edit URL is present in the response, we do not show the project
        //when the project is mobile project and portability iss off, then we do not show the project
        //@ts-ignore
        if (project.resource.editProjectUrl === undefined || (!photoOrg.config.projects_portability && project.resource.sourceGroup && (project.resource.sourceGroup.indexOf('sf-mobile-ios') !== -1 || project.resource.sourceGroup.indexOf('sf-mobile-android') !== -1))) return '';

        var html;
        //project name from response
        var projectName = project.resource.projectName;

        var projectDate = getProjectDate(project);

        var project_resource = Object.assign({}, project.resource);
        project_resource.projectDate = projectDate.formattedDate;
        //If project name is not available than we are adding product type name
        if (projectName === undefined || projectName.length === 0) {
            projectName = project.resource.projectType.name;
        }
        //Encoding the project name
        //@ts-ignore
        project_resource.projectName = photoOrg.Util.encodeEntities(projectName);
        project_resource.projectMonth = projectDate.month;
        var group = project.resource.projectType.name;
        project_resource.projectType = group;

        //The condition is to hide/show the deleteIcon on the projects.
        project_resource.showDeleteIcon = false;

        if (project_resource.state == 'Free' || (project_resource.state == 'Archived')) {
            project_resource.showDeleteIcon = true;
        }
        var projectDetails;
        //We are using projectInfoMap data for hover component, we don't need this data as we don't have hover component for deleted projects

        //Creating an object to have all the required data for creating a project.
        project_resource.month = projectDate.month;
        project_resource.year = projectDate.year;
        project_resource.state = project.resource.state
        project_resource.group = group;
        project_resource.dimensions = false;
        project_resource.currentState = projectState;//Appending the project current tab state.
        

        return <Project {...project_resource}></Project>;
    }catch(e){
        //@ts-ignore
        photoOrg.clientLogger.error({description: "NEW PROJECTS:projects_view:createTemplate:Exception", errorCode: "LIBRARY:MYPROJECTS", err_desc: e, err_stack: e.stack});
    }
}

const createMonthHeaderForProject=  (projectDate,projectState,children,ref) => {    
    if(projectState !== 'deleted'){
        const context = getmonthHeaderData(projectDate,"");
        //The template for displaying the date bar is added
        return (<React.Fragment>
            <p ref={el => ref.current[context.year] = el} className={`grip_p grid_${context.year} yearP addStickyHeader`} >
                <h1 className="grid-project-date">{context.date}</h1><span className="project-count"></span>
            </p>
            <ul className={`large-block-grid-4 text-center grid_${context.year} projects-grid-ul`}>{children}</ul>
        </React.Fragment>)
    }else {        
        return <ul className="large-block-grid-4 text-center projects-grid-ul">{children}</ul>               
    }
}

const getProjectDate = (project) => {
    var projectDate = {
        originalDate: "",
        permanentdeleteDate: "",
        formattedDate: "",
        year: 0,
        month: "",
    };
    //projectDate from response
    projectDate.originalDate  = project.resource.updateDate;
    //If no update is present then pick createDate as the project date.
    if(project.resource.updateDate === undefined || project.resource.updateDate == null || project.resource.updateDate.length === 0) {
        projectDate.originalDate = project.resource.createDate;
    }
    //Project deletion date is only available for deleted projects which should be shown instead of modified date
    if(project.resource.deletionDate) {
        //@ts-ignore
        projectDate.permanentdeleteDate =  moment(project.resource.deletionDate).format(photoOrg.config.date_format);
    }
    //@ts-ignore
    projectDate.formattedDate = moment(projectDate.originalDate).format(photoOrg.config.date_format);
    var arr = projectDate.originalDate.split(/[- :T]/).map(Number); // from your example var date = "2012-11-14T06:57:36+0000";
    var originalDate = new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], 0);
    projectDate.year = originalDate.getFullYear();
    projectDate.month = monthNames[originalDate.getMonth()];
    projectDate.originalDate = originalDate.getMonth()+1 +"/"+ originalDate.getDate() +"/"+ originalDate.getFullYear();

    return projectDate;
}

interface ProjectsListProps {
    data: resource[];
    projectState: makeProjectsActionType;
    ref: React.Ref<Object>
}

const ProjectsList: React.FC<ProjectsListProps> = forwardRef(({data, projectState},ref) => {
    let projectsList = prepareYearWiseProjectList(data);   
    
    //as no polyfill for Object.values in IE 11 browser 
    let values = Object.keys(projectsList).map(function(e) {
        return projectsList[e];
      })


    let projectsDivMonthWise = values.map((key, val) => {   //preparing the html in a string and appending to the dom on monthly projects cluster
        
        //val = val.replace('y', '');
        let value = key[0]
        var projectDate = getProjectDate(value);

        let children = key.map((project)=> {   //iterating for preparing all the projects of a month in a single string
            if (project.resource.version === "2.0") {  // as we are getting the thumbnailurl as part of iconUrl attribute for projects v2 api call, replacing the thumbnail url with iconUrl
                //If iconUrl is not available then get the thumbnail Url.
                project.resource.thumbnailUrl = project.resource.iconUrl ? project.resource.iconUrl : project.resource.thumbnailUrl;
            }            
            return (<React.Fragment key={project.resource.id}>
                      {createTemplate(project, projectState)}          
            </React.Fragment>);            
        })

        return (<React.Fragment key={projectDate.originalDate}>
                    {createMonthHeaderForProject(projectDate, projectState,children,ref)}
        </React.Fragment>);
    })
    return (<React.Fragment>        
            {projectsDivMonthWise}
            
        </React.Fragment>)
})


export default ProjectsList;